module.exports = __webpack_public_path__ + "completedDay-c2ff3449bcbfa38055da028285355b7f.png";